import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PayrollPeriod } from '@/entities/PayrollPeriod/PayrollPeriod'
import {
    addDays,
    addHours,
    eachDayOfInterval,
    setHours,
    setMinutes,
    setSeconds,
    startOfWeek,
} from '@/helpers/date'
import { AsyncReduxState, initialAsyncReduxState } from '@/redux/@config/AsyncReduxState'
import { TimeModeType } from '@/types'

export type CalendarState = AsyncReduxState<{
    activePayrollPeriod?: PayrollPeriod
    selectedDays: Date[]
    selectedMobileDay: Date
    timeMode: TimeModeType
    year: number
}>

const defaultStartDay = setSeconds(setMinutes(setHours(addHours(new Date(), -4), 4), 0), 0)
const defaultStartOfWeek = startOfWeek(defaultStartDay, { weekStartsOn: 1 })

const initialState: CalendarState = {
    ...initialAsyncReduxState,
    selectedDays: eachDayOfInterval({ start: defaultStartOfWeek, end: addDays(defaultStartOfWeek, 6) }),
    selectedMobileDay: defaultStartDay,
    timeMode: TimeModeType.week,
    year: defaultStartDay.getFullYear(),
}

export const calendarSlice = createSlice({
    name: 'calendarReducer',
    initialState,
    reducers: {
        setActivePayrollPeriod(state, action: PayloadAction<PayrollPeriod | undefined>): CalendarState {
            return {
                ...state,
                activePayrollPeriod: action.payload,
            }
        },
        setSelectedDays(state, action: PayloadAction<Date[]>): CalendarState {
            return {
                ...state,
                selectedDays: action.payload,
            }
        },
        setSelectedMobileDay(state, action: PayloadAction<Date>): CalendarState {
            return {
                ...state,
                selectedMobileDay: action.payload,
            }
        },
        setTimeMode(state, action: PayloadAction<TimeModeType>): CalendarState {
            return {
                ...state,
                timeMode: action.payload,
            }
        },
        setYear(state, action: PayloadAction<number>): CalendarState {
            return {
                ...state,
                year: action.payload,
            }
        },
    },
})

export const {
    setActivePayrollPeriod,
    setSelectedDays,
    setSelectedMobileDay,
    setTimeMode,
    setYear,
} = calendarSlice.actions

export const calendarReducer = calendarSlice.reducer
